<template>
  <ais-instant-search index-name="alg_properties" :search-client="searchClient">
    <!-- :hits-per-page.camel="10" -->
    <ais-configure>
      <ais-autocomplete>
        <template v-slot="{ currentRefinement, indices, refine }">
          <form class="md:flex md:flex-row">
            <div class="input__field">
              <input
                type="text"
                id="input-search"
                :value="currentRefinement"
                class="search-bar h-14 w-full"
                :class="{ 'search-bar-border': currentRefinement }"
                placeholder="Encuentra la finca que necesitas"
                @input="refine($event.currentTarget.value)"
              />
              <span
                v-if="currentRefinement"
                class="icon-x text-agrogo-yellow-1 icon_x"
                @click.prevent="refine(($event.currentTarget.value = ''))"
              ></span>
            </div>
            <button
              type="submit"
              class="icon-search-bar w-16 h-14 text-2xl transform transition-all hover:scale-110"
              :class="{ 'icon-search-bar-boder': currentRefinement }"
              @click.prevent="redirectListFarm(currentRefinement)"
            ></button>
          </form>
          <div v-if="currentRefinement">
            <div v-for="index in indices" :key="index.indexId">
              <div
                class="md:flex md:flex-row bg-white px-1 pb-1 space-y-2 flex-wrap"
              >
                <div class="w-full bg-agrogo-green-2">
                  <div
                    class="flex items-center justify-start h-9 bg-agrogo-gray-1 pl-10"
                  >
                    <p
                      class="text-base font-dinpro font-normal text-agrogo-black-1"
                    >
                      Se han encontrado
                      {{ index.hits.length }} resultados
                    </p>
                  </div>
                  <div class="search-home-style z-30">
                    <div
                      v-for="item in index.hits"
                      :key="item.objectID"
                      class="bg-agrogo-green-2 cursor-pointer"
                      @click.prevent="sendDetail(item)"
                    >
                      <div class="bg-agrogo-green-2">
                        <div
                          :id="'style-search-home' + item.id"
                          class="container-search-home"
                        >
                          <div class="flex px-12 py-2 justify-between">
                            <div class="h-auto flex items-center">
                              <div class="flex flex-col space-y-2">
                                <p
                                  class="text-xs md:text-lg text-left font-nexa font-normal"
                                >
                                  {{ item.name }}
                                </p>
                                <!-- <p
                                  class="text-xs md:text-base text-left font-nexa"
                                >
                                  {{ item.municipality_id.name }},
                                  <b>{{ item.department_id.name }}</b>
                                </p> -->
                                <div
                                  class="grid grid-cols-4 lg:grid-cols-3 xl:grid-cols-8 text-center"
                                >
                                  <span
                                    v-for="category in item.alg_categories.slice(
                                      0,
                                      3
                                    )"
                                    :key="category.id"
                                    class="text-agrogo-yellow-1 mr-2 text-2xl"
                                    :class="category.icon_subcategory"
                                  ></span>
                                  <span
                                    v-if="item.alg_categories.length > 3"
                                    class="text-agrogo-yellow-1 text-2xl"
                                  >
                                    ...
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="flex flex-col justify-between">
                              <p
                                class="flex items-start justify-end text-xs md:text-base font-dinpro font-normal opacity-80"
                              >
                                <span>ID#</span>
                                {{ item.property_id }}
                              </p>
                              <div class="flex flex-col items-end justify-end">
                                <p
                                  class="flex text-right text-base md:text-2xl font-dinpro font-normal opacity-80"
                                >
                                  <span
                                    class="icon-signo-pesos text-sm md:text-xl mr-1 mt-1 opacity-100"
                                  ></span>
                                  {{ formatThousand(item.price) }}
                                </p>
                                <p
                                  class="font-dinpro font-normal text-xs text-agrogo-gray-1 text-right"
                                >
                                  (Pesos Colombianos)
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </ais-autocomplete>
    </ais-configure>
  </ais-instant-search>
</template>

<script>
// Algolia
import algoliasearch from "algoliasearch/lite";

export default {
  data() {
    const algoliaId =
      process.env.VUE_APP_DEBUG == "true"
        ? process.env.VUE_APP_ALGOLIA_ID_TEST
        : process.env.VUE_APP_ALGOLIA_ID;
    const algoliaPrivateKey =
      process.env.VUE_APP_DEBUG == "true"
        ? process.env.VUE_APP_PRIVATE_KEY_ALGOLIA_TEST
        : process.env.VUE_APP_PRIVATE_KEY_ALGOLIA;
    return {
      searchClient: algoliasearch(algoliaId, algoliaPrivateKey),
    };
  },
  methods: {
    formatThousand(number) {
      const formatterPeso = new Intl.NumberFormat("es-CO", {
        currency: "COP",
        minimumFractionDigits: 0,
      });
      number = formatterPeso.format(number);
      return number;
    },
    sendDetail(item) {
      const me = this;
      me.$router.push({ name: "FarmDetail", params: { slug: item.slug } });
    },
    redirectListFarm(text) {
      const me = this;
      if (text) {
        me.$router.push({
          name: "ListOfFarms",
          query: { buscar: text },
        });
      }
    },
  },
};
</script>

<style lang="css">
.input__field {
  width: 100%;
  display: flex;
  position: relative;
}
.icon_x {
  position: absolute;
  left: 12px unset;
  top: 50%;
  transform: translateY(-50%);
  font-size: 15px;
  right: 12px;
  cursor: pointer;
}
</style>
